const MIN_PRICE = 0.00000001;

export function generateInitialHistory(startPrice, points = 150) {
  const now = Math.round((Date.now() / 1000) * 10) / 10;
  const safeStart = Math.max(MIN_PRICE, startPrice);

  // Generate ~120 points of smooth mean-reverting random walk.
  // Amplitude matches live feed's TICK_INTERPOLATION_VOLATILITY_RATIO
  // so the seed data has visible variation consistent with live ticks
  // instead of appearing as a flat horizontal line.
  const actualPoints = Math.min(points, 120);
  const history = [];

  const microAmp = safeStart * 0.000048;
  let walkPrice = safeStart;
  let velocity = 0;

  for (let i = 0; i <= actualPoints; i++) {
    const time = Math.round((now - (actualPoints - i) * 0.3) * 10) / 10;

    // Smooth random walk with mean reversion toward starting price
    const meanRevert = (safeStart - walkPrice) * 0.03;
    const randomImpulse = (Math.random() - 0.5) * microAmp * 1.2;
    velocity = velocity * 0.7 + (meanRevert + randomImpulse) * 0.3;
    walkPrice += velocity;
    walkPrice = Math.max(MIN_PRICE, walkPrice);

    const value = roundPriceByMagnitude(walkPrice);
    history.push({ time, value });
  }

  // Pin the last point exactly to the starting price for seamless live transition
  history[history.length - 1] = {
    time: now,
    value: roundPriceByMagnitude(safeStart)
  };

  return history;
}

export function roundPriceByMagnitude(price) {
  if (price >= 1000) return Math.round(price * 100) / 100;
  if (price >= 1) return Math.round(price * 1000) / 1000;
  if (price >= 0.1) return Math.round(price * 10000) / 10000;
  return Math.round(price * 100000) / 100000;
}
